export enum OrderOptimizerListRequestStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

export type OrderOptimizerListRequestQueryParams = {
  limit?: number;
  offset?: number;
  orderHumanId?: number;
  maximumDelay?: number;
  maximumHaltingTime?: number;
  mergePlanEntries?: boolean;
  ignoreTaxi?: string[];
  ignoreOnlyWithTaxi?: string[];
  ignoreCargo?: string[];
  ignoreOnlyWithCargo?: string[];
  status?: OrderOptimizerListRequestStatus;
  excludeStatus?: OrderOptimizerListRequestStatus;
};

type OrderOptimizerListRequest = {
  limit?: number;
  offset?: number;
  orderHumanId?: number;
  maximumDelay?: number;
  maximumHaltingTime?: number;
  mergePlanEntries?: boolean;
  ignoreTaxi?: string[];
  ignoreOnlyWithTaxi?: string[];
  ignoreCargo?: string[];
  ignoreOnlyWithCargo?: string[];
  status?: OrderOptimizerListRequestStatus;
  excludeStatus?: OrderOptimizerListRequestStatus;
};
export default OrderOptimizerListRequest;
